// extracted by mini-css-extract-plugin
module.exports = {"byline":"_bc8a986b","large":"_e44b30a3","internalByline":"_41e7692c","titleWrapper":"_61da5c0d","hasByLine":"_de88e491","titleOneLine":"_da3ba7b4"};